/* import __COLOCATED_TEMPLATE__ from './protect-your-messenger.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();